import { FocusEventHandler } from 'react'

import { type Props as FieldProps } from '../BaseField'
import { RawIndependentDatetimePicker } from './RawDatetimePicker'
import { RawIndependentDateMonthPicker } from './RawIndependentDateMonthPicker'
import { RawIndependentDatePicker } from './RawIndependentDatePicker'
import { RawIndependentTimePicker } from './RawIndependentTimePicker'

export type IndependentDateProps = Date | string | moment.Moment | null

export type IndependentDatetimePickerProps = {
  id?: string
  name?: string
  onBlur?: FocusEventHandler<HTMLElement>
  initialValue?: string | moment.Moment | Date
  value?: string | moment.Moment | Date
  onChange?: (value: string) => void
  minDate?: IndependentDateProps
  maxDate?: IndependentDateProps
  disabled?: boolean
  showTime?: boolean
  type?: 'date' | 'datetime' | 'time' | 'month'
  showPastOnly?: boolean
  showFutureOnly?: boolean
  picker?: 'month'
  willShowNotAllowedCursor?: boolean
  readonly?: boolean
  placeholder?: string
  className?: string
  fatherWidth?: number
} & Omit<FieldProps, 'children'>

export const IndependentDatetimePicker = ({
  type = 'date',
  showTime,
  picker,
  ...props
}: IndependentDatetimePickerProps) => {
  if (type === 'date' && !showTime && picker !== 'month') {
    return <RawIndependentDatePicker {...props} />
  }
  if ((type === 'datetime' || showTime) && picker !== 'month') {
    return <RawIndependentDatetimePicker {...props} />
  }
  if (type === 'time') {
    return <RawIndependentTimePicker {...props} />
  }
  if (type === 'month' || picker === 'month') {
    return <RawIndependentDateMonthPicker {...props} />
  }

  return null
}
